import React from 'react';
import { FadeIn } from './FadeIn';
export function Testimonials() {
  const testimonials = [{
    quote: 'Llevaba 3 años tomando pastillas para dormir. Con la Leche de Luna del libro dormí 7 horas el primer día. No lo podía creer.',
    author: 'Carmen R.',
    age: '68 años',
    location: 'Miami FL'
  }, {
    quote: 'Mi rodilla derecha no me dejaba jugar con mis nietos. Después de dos semanas con el Té Dorado y las sales, bajé las escaleras sin agarrarme del barandal. Lloré de alegría.',
    author: 'Rosa M.',
    age: '71 años',
    location: 'Houston TX'
  }, {
    quote: 'Pensé que era otro libro más. Pero cuando vi que todos los ingredientes los encontré en mi Walmart de siempre y en español... supe que era diferente.',
    author: 'Gloria P.',
    age: '66 años',
    location: 'Chicago IL'
  }];
  return <section className="py-20 px-6 bg-cream-dark/30" data-id="element-217">
      <div className="max-w-5xl mx-auto" data-id="element-218">
        <FadeIn data-id="element-219">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brown-dark mb-16" data-id="element-220">
            Lo Que Dicen Nuestras Lectoras
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-221">
            {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-222">
                <div className="bg-white p-8 rounded-3xl shadow-lg border border-cream-dark relative h-full flex flex-col" data-id="element-223">
                  <div className="text-amber text-4xl mb-4" data-id="element-224">"</div>
                  <p className="text-lg text-brown italic mb-6 flex-grow" data-id="element-225">
                    {testimonial.quote}
                  </p>
                  <div className="mt-auto" data-id="element-226">
                    <div className="flex text-amber mb-2" data-id="element-227">⭐⭐⭐⭐⭐</div>
                    <p className="font-bold text-brown-dark" data-id="element-228">
                      {testimonial.author}
                    </p>
                    <p className="text-sm text-brown-light" data-id="element-229">
                      {testimonial.age}, {testimonial.location}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}